import { VALUES } from "../../data/content";

export const Marquee = () => {
  const items = [...VALUES, ...VALUES];
  return (
    <section
      data-testid="values-marquee"
      className="relative overflow-hidden border-y border-pblv-ink/10 bg-pblv-bg2 py-8 md:py-10"
      aria-label="Nos valeurs"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-pblv-bg2 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-pblv-bg2 to-transparent" />
      <div className="pblv-marquee-track">
        {items.map((v, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-serif text-3xl italic text-pblv-ink md:text-5xl">
              {v}
            </span>
            <span className="text-2xl text-pblv-rose md:text-3xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
